var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0001 49.9998C38.8072 49.9998 50.0001 38.8069 50.0001 24.9998C50.0001 11.1926 38.8072 -0.000244141 25.0001 -0.000244141C11.193 -0.000244141 0.00012207 11.1926 0.00012207 24.9998C0.00012207 38.8069 11.193 49.9998 25.0001 49.9998Z",
    fill: "#EF0027"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2688 15.4886L11.7188 11.3386L23.586 41.2011L40.1219 21.0542L34.2688 15.4886ZM33.9063 17.3167L37.3563 20.5964L27.9219 22.3042L33.9063 17.3167V17.3167ZM25.8719 21.9621L15.9282 13.7152L32.1813 16.7058L25.8719 21.9621V21.9621ZM25.1641 23.4214L23.5422 36.8277L14.8001 14.823L25.1641 23.4199V23.4214ZM26.6641 24.1324L37.1126 22.2417L25.1282 36.8402L26.6641 24.1324Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedIcon);
export default __webpack_public_path__ + "static/media/red-icon.e8369847d7d45898a6194d4ee6675c78.svg";
export { ForwardRef as ReactComponent };